import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';

const Address = (_param)=>{
    var { className , rows , children  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "rows",
        "children"
    ]);
    return rows.length || Boolean(children) || Array.isArray(children) && children.length > 0 ? /*#__PURE__*/ React.createElement("address", swcHelpers.extends({}, rest, {
        className: classnames('address-stores-v2', className)
    }), rows.map((row, index)=>/*#__PURE__*/ React.createElement("span", {
            key: `${row}-${index}`,
            className: "address-stores-v2__row"
        }, row)
    ), children) : null;
};

export { Address as default };
//# sourceMappingURL=Address.js.map
